import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import * as Models from '@shared/models';
import { handleError } from '@core/utils';
import { ConfigService } from '../services/config.service';

export interface IAuditApi {
  getAuditHistory(request: Models.IAuditRequestModel): Observable<Models.IAuditResponse[]>;
}

@Injectable({
  providedIn: 'root',
})
export class AuditApi {
  private serviceBase = '';

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) {
    this.configService.Config.subscribe((config) => {
      if (!config) return;
      this.serviceBase = config.apiUri;
    });
  }

  getAuditHistory(request: Models.IAuditRequestModel): Observable<Models.IAuditResponse[]> {
    return this.http
      .post<
        Models.IAuditResponse[]
      >(this.serviceBase + '/audit/getAudits', JSON.stringify(request), { headers: { 'Content-Type': 'application/json' } })
      .pipe(
        map((response: Models.IAuditResponse[]) => {
          return response;
        }),
        catchError(handleError<Models.IAuditResponse[]>('GetAudits', []))
      );
  }
}
